var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('base-input',{directives:[{name:"validate",rawName:"v-validate",value:({snils:true}),expression:"{snils:true}"}],attrs:{"type":"text","name":_vm.errorLabel,"error":_vm.getError(_vm.errorLabel),"placeholder":_vm.placeholder},model:{value:(_vm.bufferValue),callback:function ($$v) {_vm.bufferValue=$$v},expression:"bufferValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }